export const SINGLE = 0;
export const FUTURE_EVENTS = 1;
